import { Checkbox as MuiCheckbox, CheckboxProps, styled } from '@mui/material';

const Checkbox: React.FC<CheckboxProps & { error: boolean }> = props => <MuiCheckbox {...props} />;

const StyledCheckbox = styled(Checkbox, { shouldForwardProp: prop => prop !== 'error' })(({ error, theme }) => ({
	color: `${error ? theme.palette.error.main : theme.palette.gray.dark} !important`,
}));

type CerebroCheckboxProps = Omit<CheckboxProps, 'value'> & { value: boolean; error?: boolean };

export const CerebroCheckbox: React.FC<CerebroCheckboxProps> = ({ error = false, ...props }) => (
	<StyledCheckbox error={error} {...props} checked={props.value} />
);
